"use client";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
export function PortfolioViewTracker({ profileId, itemId }: { profileId: string; itemId: string }) {
  useEffect(() => {
    const key = `portfolio-view-${itemId}`;
    try {
      if (Date.now() - Number(localStorage.getItem(key) || 0) < 3600000) return;
      localStorage.setItem(key, String(Date.now()));
      void supabase.auth.getUser().then(({ data }) => {
        return supabase.from("portfolio_item_views" as never).insert({ profile_id: profileId, portfolio_item_id: itemId, viewer_id: data.user?.id || null } as never);
      });
    } catch { /* Storage can be unavailable; reading the work must still succeed. */ }
  }, [profileId, itemId]);
  return null;
}
